import {createReducer, on} from "@ngrx/store";
import * as PlanetActions from './planet.actions';
import {Planet} from "../../models/Planet";
export const planetFeatureKey = 'planet';
export const universeInitialState: Planet | null = null;
export const planetReducer = createReducer<Planet | null>(
  universeInitialState,
  on(PlanetActions.update, (_state, { planet }) => planet),
);
